import {
  groupByDesign,
  useProject,
} from '@customink/project-service-react-components';

import { ORDER_TYPES } from '@/constants';

export const useOrderQuantityType = () => {
  const { data: project } = useProject();
  const projectItemGroups = groupByDesign(project?.items ?? []);

  const groupTotals = Object.values(projectItemGroups).map((group) =>
    group.reduce((acc, item) => acc + (item?.totalQuantity ?? 0), 0),
  );

  const hasReorder = project?.items?.some(
    (item) => item.sampleType === 'reorder',
  );

  if (hasReorder) return ORDER_TYPES.REORDER;

  if (groupTotals.every((total) => total < 6)) {
    return ORDER_TYPES.SINGLES;
  } else if (groupTotals.every((total) => total >= 6)) {
    return ORDER_TYPES.BULK;
  } else {
    return ORDER_TYPES.MIXED;
  }
};
